/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Reasons_Allocationcapacityconstraints4Inputs */

const en_coinvestments_declinedeal_reasons_allocationcapacityconstraints4 = /** @type {(inputs: Coinvestments_Declinedeal_Reasons_Allocationcapacityconstraints4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocation capacity constraints`)
};

/**
* | output |
* | --- |
* | "Allocation capacity constraints" |
*
* @param {Coinvestments_Declinedeal_Reasons_Allocationcapacityconstraints4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_reasons_allocationcapacityconstraints4 = /** @type {((inputs?: Coinvestments_Declinedeal_Reasons_Allocationcapacityconstraints4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Reasons_Allocationcapacityconstraints4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_reasons_allocationcapacityconstraints4(inputs)
});
export { coinvestments_declinedeal_reasons_allocationcapacityconstraints4 as "coInvestments_declineDeal_reasons_allocationCapacityConstraints" }